import * as actionTypes from "../actionTypes";

export const getSiteWastes = function (siteId) {
  return { type: actionTypes.GET_SITE_WASTES, payload: siteId };
};
